/**
 * バリデーションメッセージのオブジェクト
 * @constant {object} twMessages
 */
const twMessages = {
    REQUIRED: '請輸入。',
    REQUIRED_SELECT: '請選擇。',
    ANY_REQUIRED: '1ヵ所以上、請輸入。',
    TEL: '電話號碼格式錯誤。',
    MAIL: '郵件地址格式錯誤。',
    NUM: '請輸入半形數字。',
    ALPHABET: '請輸入英文字母。',
    ALPHA_NUM: '請輸入半形英數字。',
    ZIP: '郵遞區號格式錯誤。',
    ADDR: '不存在的郵遞區號。',
    KANA: '請輸入平假名或片假名。',
    HIRAGANA: '請輸入平假名。',
    KATAKANA: '請輸入片假名。',
    NO_INPUT: '有輸入錯誤的項目。',
};
export default twMessages;
//# sourceMappingURL=tw.js.map